import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AttendanceSheetLulSummaryModule } from '@neworg/attendancesheet-lul-summary';
import { ClockingEntryModule } from '@neworg/clocking-entry';
import { DialogMessageModule } from '@neworg/dialog-message';
import { EmployeeCausalRequestListModule } from '@neworg/employee-causal-request-list';
import { EmployeeRefundedCostsModule } from '@neworg/employee-refunded-costs';
import { PartyAccrualsModule } from '@neworg/party-accruals';
import { PartyClockingDayModule } from '@neworg/party-clocking-day';
import { PartySearchModule } from '@neworg/party-search';
import { PartySharedLastDocumentsModule } from '@neworg/party-shared-lastdocuments';

import { apps } from '../../constants';
import { CompanyProperty, UserProperty } from '../../properties';
import { AppService, SessionService } from '../../services';
import { DebugLoggerService } from '../../services/debug-logger.service';
import { AppStateHolder } from '../../shared';
import { SmartBoxV2Component } from '../smart-box-v2/smart-box-v2.component';
import { PartyProfilerComponent } from '../widgets/party-profiler/party-profiler.component';
import { LastUsedTemplatesComponent } from '../widgets/sa-last-used/last-used.component';
import { ActivityHourChartComponent } from '../widgets/user-activities/activity-hour-chart/activity-hourChart.component';
import { ActivityHourPopUpComponent } from '../widgets/user-activities/activity-hour-chart/activity-hourPopup.component';
import { ActivityStateChartComponent } from '../widgets/user-activities/activity-state-chart/activity-stateChart.component';
import { ActivityStatePopUpComponent } from '../widgets/user-activities/activity-state-chart/activity-statePopup.component';
import { ActivityTypologyChartComponent } from '../widgets/user-activities/activity-typology-chart/activity-typologyChart.component';
import { ActivityTypologyPopUpComponent } from '../widgets/user-activities/activity-typology-chart/activity-typologyPopup.component';
import { ActivityPopUpComponent } from '../widgets/user-activities/activity-popup.component';
import { UserActivitiesComponent } from '../widgets/user-activities/user-activities.component';
import { ProjectPopUpComponent } from '../widgets/user-projects/project-popup.component';
import { UserProjectsComponent } from '../widgets/user-projects/user-projects.component';
import { LastPartiesComponent } from '../widgets/wp-last-used/crm-lastUsed.component';
import { MoreUsedComponent } from '../widgets/wp-more-used/more-used.component';

@Component({
  selector: 'dynamic-widgets',
  templateUrl: './dynamic-widgets.component.html',
  standalone: true,
  imports: [
    SmartBoxV2Component,
    LastPartiesComponent,
    MoreUsedComponent,
    PartySearchModule,
    UserActivitiesComponent,
    ActivityPopUpComponent,
    ActivityStateChartComponent,
    ActivityStatePopUpComponent,
    ActivityTypologyChartComponent,
    ActivityTypologyPopUpComponent,
    ActivityHourChartComponent,
    ActivityHourPopUpComponent,
    EmployeeRefundedCostsModule,
    UserProjectsComponent,
    ProjectPopUpComponent,
    LastUsedTemplatesComponent,
    EmployeeCausalRequestListModule,
    ClockingEntryModule,
    AttendanceSheetLulSummaryModule,
    DialogMessageModule,
    PartyAccrualsModule,
    PartySharedLastDocumentsModule,
    PartyClockingDayModule,
    PartyProfilerComponent,
  ],
})
export class DynamicWidgetsComponent implements OnInit {
  userProperty = inject(UserProperty);
  appStateHolder = inject(AppStateHolder);
  appService = inject(AppService);
  companyProperties = inject(CompanyProperty);
  private _router = inject(Router);
  sessionService = inject(SessionService);
  private _debugLogger = inject(DebugLoggerService);

  @Input() widget;
  @Input() resizeEvent;
  @Input() modify;
  @Input() currentDashboard;

  @Output() dashboardEdited: EventEmitter<any> = new EventEmitter();

  @Input() modi: Boolean = false;
  @Input() statepop: Boolean = false;

  selectedState: any;
  selectedStateParams: any;

  pjpop: Boolean = false;
  typologypop: Boolean = false;

  selectedProj: any;
  selectedPjParams: any;
  activpop: Boolean = false;
  hourpop: Boolean = false;
  selectedHour: any;
  selectedHourParams: any;

  selectedTypology: any;
  selectedTypologyParams: any;

  smartBoxViewapps: any;
  selectedAct: any;
  selectedActParams
  smartBoxId: any;

  params: any

  month: number = new Date().getMonth() + 1;
  year: number = new Date().getFullYear();



  // params: any = {
  //   viewType: null,
  //   id: null,
  //   label: null
  // }

  ngOnInit(): void {
    this._debugLogger.logLifecycle('DynamicWidgets', 'ngOnInit');
  }

  projectPopUp(event: any) {
    this._debugLogger.logAction('DynamicWidgets', 'projectPopUp', { widx: event.widx });
    this.pjpop = true;
    this.selectedProj = event.widx;
    this.selectedPjParams = event.params;
  }

  setSmartBoxIndex(index: any) {
    this.smartBoxId = index;
  }

  changeModi(mod: boolean) {
    this.modi = false;
  }

  hourPopUp(event: any) {
    this.hourpop = true;
    this.selectedHour = event.widx;
    this.selectedHourParams = event.params;
  }

  hourPopClose(event: boolean) {
    this.hourpop = !event;
  }

  statepopUp(event: any) {
    this.statepop = true;
    this.selectedState = event.widx;
    this.selectedStateParams = event.params;
  }

  actpopUp(event: any) {
    this._debugLogger.logAction('DynamicWidgets', 'actpopUp', { widx: event.widx });
    this.activpop = true;
    this.selectedAct = event.widx;
    this.selectedActParams = event.params;

  }

  actPopClose(event: boolean) {
    this.activpop = !event;
  }

  statePopClose(event: boolean) {
    this.statepop = !event;
  }


  pjPopclose(event: boolean) {
    this.pjpop = !event;
  }

  typologyPopClose(event: boolean) {
    this.typologypop = !event;
  }

  /**
   * Saves the widget parameters.
   * @param data - The data containing the widget parameters and index.
   */
  saveWidgetParams(data: any) {
    this._debugLogger.logAction('DynamicWidgets', 'saveWidgetParams', { indx: data?.indx });
    let newParams = {
      params: JSON.stringify(data.params),
      indx: data.indx
    }
    if (this.currentDashboard) {
      let widgetToEdit = this.currentDashboard.find(w => w.idx === data.indx);
      let params = typeof newParams !== 'string' ? JSON.stringify(newParams) : newParams;

      widgetToEdit.dashboardAssociationParamValue = params;
      this.dashboardEdited.emit(this.currentDashboard);
    }
  }

  /**
   * Saves the parameters for the smart box.
   * @param params - The parameters to be saved.
   */
  saveSmartBoxParams(params: any) {
    if (params) {

      let newParams = {
        params: JSON.stringify(params),
        indx: this.smartBoxId
      }

      if (this.currentDashboard) {
        let widgetToEdit = this.currentDashboard.find(w => w.idx === this.smartBoxId);

        widgetToEdit.dashboardAssociationParamValue = newParams.params;
        this.dashboardEdited.emit(this.currentDashboard);
        this.modi = false;
      }
    }
  }

  /**
   * Selects a party and navigates to the corresponding page.
   * @param {any} party - The party object to be selected.
   */
  selectParty(party) {
    this._debugLogger.logAction('DynamicWidgets', 'selectParty', { id: party?.id });
    if (party === undefined)
      return;

    let url = this.appStateHolder.getAppUrl(apps.crm);
    this.appStateHolder.setAppNavbarClass(apps.crm);

    if (url.length === 0) {
      let link = ['/console', party.id];
      this._debugLogger.logNavigation(link.join('/'));
      this._router.navigate(link)
    }

    let link = ['/app', `${url}/console/${party.id}`];
    this._debugLogger.logNavigation(link.join('/'));
    this._router.navigate(link);
  }

  /**
   * Navigates to the clocking page.
   *
   * @param event - The event object.
   */
  navigateToClocking(event: any) {
    this._debugLogger.logNavigation('clocking', { appId: event.appId });
    this.appStateHolder.setAppNavbarClass(apps.clocking);
    this._router.navigate(['app', event.appId]);
  }

  /**
   * Navigates to the archive page for the specified app.
   * @param event - The event object containing the appId.
   */
  navigateToArchive(event: any) {
    this._debugLogger.logNavigation('archive', { appId: event.appId });
    this.appStateHolder.setAppNavbarClass(event.appId);
    this._router.navigate(['app', event.appId]);
  }

  /**
   * Opens the typology pop-up and sets the selected typology and its parameters.
   *
   * @param event - The event object containing the typology index and parameters.
   */
  typologyPopUp(event: any) {
    this.typologypop = true;
    this.selectedTypology = event.widx;
    this.selectedTypologyParams = event.params;
  }
}
